module.exports = __webpack_public_path__ + "img/w3_circle_add_light.faa53271.png";